var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"app-course",attrs:{"target":"_blank","href":_vm.links[_vm.name]}},[_c('i',{staticClass:"icon-course"}),_vm._v("教程 ")])}
var staticRenderFns = []

export { render, staticRenderFns }